<div class="form-group">
  <label>名前</label>
  <input class="form-control" [(ngModel)]="initialCostMaster.name" />
</div>
